/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import Insight360ToolPalate from '../components/common/Insight360ToolPalate';
import Insight360Content from './Insight360Content';
import * as insight360Actions from '../actions/insight360Actions';
import * as preferenceActions from '../actions/preferencesActions';
import { saveTrackingData, storeUnsavedData } from '../util/trackerUtils';
import { PAGE_VISIT_BRAND_CATALYST, BRAND_CATALYST_FEATUREID } from '../constants';
import { isFeaturePresent } from '../util/CommonUtils';
import BrandCatalystComingSoonToolPalate from
  '../components/insights360/BrandCatalystComingSoonTeaser/BrandCatalystComingSoonToolPalate';
import BrandCatalystComingSoonTeaser from
  '../components/insights360/BrandCatalystComingSoonTeaser/BrandCatalystComingSoonTeaser';
import WarningIcon from './WarningIcon';
import * as definitionActions from '../actions/definitionActions';

class Insight360 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 'EXPLORE',
      smartSearchStudy: undefined,
      hasBCStudies: true,
    };
  }

  componentDidMount() {
    sessionStorage.removeItem('subModule');
    this.onMountMethod();
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.hasBCStudies !== nextProps.hasBCStudies) {
      this.setState({ hasBCStudies: nextProps.hasBCStudies });
    }

    if (typeof (this.props.insight360study) !== 'undefined'
      && this.props.insight360study.pn !== nextProps.insight360study.pn) {
      this.setState({ smartSearchStudy: nextProps.insight360study }, () => {
        this.fetchClusterStatement();
      });
    } else if (nextProps.insight360study) {
      this.setState({ smartSearchStudy: nextProps.insight360study });
    }
    if (nextProps.insight360study) {
      if (!_.isEqual(this.props.insight360study, nextProps.insight360study)) {
        this.props.insight360Actions.get360DemographicsFilter(
      this.props.loginResponse.data.token,
      nextProps.insight360study.pn,
    );
    this.props.definitionActions.getDefinitionTreeLoad(
      this.props.loginResponse.data.token,
      nextProps.insight360study.ss === 'SIMMONS' ? 1 : 2,
      this.props.activeAccountId,
      nextProps.insight360study.pn,
    )
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  onMountMethod = () => {
    if (this.props.loginResponse !== undefined && this.hideComingSoonTeaser()) {
      if (this.props.insight360study === undefined) {
        this.callSaveTrackerFn({ action: PAGE_VISIT_BRAND_CATALYST });
        this.props.preferenceActions.setLastLocation({
          mainMenu: 'Catalyst',
          mainModule: 'BrandCatalyst',
        });
        this.props.insight360Actions
          .get360Study(
            this.props.loginResponse.data.token,
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
          )
          .then(response => {
            if (response) {
              this.fetchClusterStatement(response.productNo);
            }
          });
      } else {
        this.callSaveTrackerFn({ action: PAGE_VISIT_BRAND_CATALYST });
        this.props.preferenceActions.setLastLocation({
          mainMenu: 'Catalyst',
          mainModule: 'BrandCatalyst',
        });
        this.setState({
          smartSearchStudy: this.props.insight360study,
        });
        this.fetchClusterStatement();
        if (this.props.insight360study !== undefined) {
          this.props.insight360Actions.get360DemographicsFilter(
          this.props.loginResponse.data.token,
          this.props.insight360study.pn,
        );
        }
      }
    }

    const { hasBCStudies } = this.props;
    if (hasBCStudies === undefined) {
      this.setState({ hasBCStudies: true });
    } else {
      this.setState({ hasBCStudies });
    }

    if (
      this.hideComingSoonTeaser() &&
      !this.props.insight360DemographicsFilterOptions &&
      this.props.loginResponse !== undefined
    ) {
      // this.props.insight360Actions.get360DemographicsFilter(
      //   this.props.loginResponse.data.token,
      //  this.props.insight360study.pn,
      // );
    }
  }


  handleLeavePage = () => {
    this.props.storeUnsavedData(
      this.props.currentState,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId
    );
  }

  fetchClusterStatement = productNo => {
    this.props.insight360Actions.fetchClusterStatements(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      typeof (productNo) !== 'undefined'
        ? productNo : this.props.insight360study.pn,
    );
  };

  selectTab = tabName => {
    this.setState({ selectedTab: tabName });
  };

  callSaveTrackerFn = ({ subModule = this.state.selectedTab, action, attributes = undefined }) => {
    const productNo = this.props.insight360study !== undefined ?
      this.props.insight360study.pn : undefined;
    if (subModule) {
      sessionStorage.setItem('subModule', subModule);
    }
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: 'BrandCatalyst',
      subModule,
      action,
      attributes,
    });
  }

  // For Coming Soon Teaser
  hideComingSoonTeaser = () => {
    const { modulePermissions } = this.props;
    let renderBrandCatalyst = false;
    if (modulePermissions.length > 0) {
      renderBrandCatalyst = isFeaturePresent(BRAND_CATALYST_FEATUREID, modulePermissions);
    }
    return renderBrandCatalyst;
  }


  render() {
    return (
      (this.hideComingSoonTeaser()) ?
        <div>
          {this.state.hasBCStudies ?
            <div>
              <Insight360ToolPalate
                dataScreen="Insight360"
                onselectedtab={this.selectTab}
                selectedTab={this.state.selectedTab}
                trackerFn={this.callSaveTrackerFn}
                studyInfo={this.state.smartSearchStudy}
              />
              <div
                className="insight360-width-955 portfolio-crosstab float-left"
                style={{
                  overflowY: 'auto',
                  height: 'calc(100vh - 57px)',
                  overflowX: 'hidden',
                }}
              >
                {this.state.smartSearchStudy ? (
                  <Insight360Content
                    selectedTab={this.state.selectedTab}
                    onselectedtab={this.selectTab}
                    smartSearchStudy={this.state.smartSearchStudy}
                    bcStudies={this.props.insight360studies}
                    trackerFn={this.callSaveTrackerFn}
                  />
                ) : (
                    ''
                  )}
              </div>
            </div> :
            <div className="no-study-message">
              <WarningIcon />
              <p>
                You do not currently have studies to the Brand Catalyst application.
                Please contact your Account Manager to learn more about your studies.
              </p>
            </div>
          }
        </div> :
        <div>
          <BrandCatalystComingSoonToolPalate />
          <div
            className="salescatalyst-width-955 portfolio-crosstab float-left"
            style={{
              overflowY: 'auto',
              height: 'calc(100vh - 57px)',
              overflowX: 'hidden',
            }}
          ><BrandCatalystComingSoonTeaser /></div>
        </div>
    );
  }
}

Insight360.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  insight360study: PropTypes.shape({
    pn: PropTypes.number,
  }),
  insight360studies: PropTypes.arrayOf(PropTypes.object),
  insight360DemographicsFilterOptions: PropTypes.shape({}),
  activeAccountId: PropTypes.number,
  insight360Actions: PropTypes.shape({
    get360Study: PropTypes.func,
    get360DemographicsFilter: PropTypes.func,
    fetchClusterStatements: PropTypes.func,
  }),
  storeUnsavedData: PropTypes.func,
  currentState: PropTypes.shape({}),
  modulePermissions: PropTypes.instanceOf(Array),
  preferenceActions: PropTypes.shape({
    setLastLocation: PropTypes.func,
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
  }),
  hasBCStudies: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    insight360study: state.study.insight360study,
    insight360studies: state.study.insight360studies,
    insight360DemographicsFilterOptions:
      state.insight360.insight360DemographicsFilterOptions,
    activeAccountId: state.account.activeAccountId,
    attitudesList:
      state.insight360.personaCreator.clusterSegments.attitudesList,
    currentState: state,
    modulePermissions: state.userDetail.permissions,
    hasBCStudies: state.study.hasBCStudies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
    storeUnsavedData: bindActionCreators(storeUnsavedData, dispatch),
    preferenceActions: bindActionCreators(preferenceActions, dispatch),
    definitionActions: bindActionCreators(definitionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Insight360);
